import {
  ApiUtility,
  IApiListResult,
  IApiResponse,
} from "../../Utilities/ApiUtility.axios";
import { LedgerStatus } from "./LedgerService";
export interface ICostCentre {
  id?: string;
  costCentreName: string;
  expenseId: string;
  status?: LedgerStatus;
  expenseLedgerName?: string;
}
export interface ICostCentresList extends ICostCentre {
  sno?: number;
}
// export interface ICostCentrePostResponse extends ICostCentre {
//   expenseLedgerName: string;
// }
export interface ICostCentresListParams {
  companyId: string;
  search?: string;
  sortCol?: string;
  sortDir?: string;
  expenseId?: string;
  status?: LedgerStatus;
  start?: number;
  length?: number;
}
class CostCentersServices {
  route = `V1/API/Billing/Acc_CostCentre`;

  postCostCenter = (companyId: string, params: ICostCentre, id?: string) =>
    ApiUtility.post<IApiResponse<ICostCentresList>>(
      `${this.route}/${companyId}${id ? "/" + id : ""}`,
      params
    );

  getCostCentersList = (
    companyId: string,
    start: number,
    length: number,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    expenseId?: string,
    status?: LedgerStatus,
  ) =>
    ApiUtility.get<IApiResponse<IApiListResult<ICostCentresList>>>(
      `${this.route}/${companyId}/GetList`,
      {
        start,
        length,
        search,
        sortCol,
        sortDir,
        expenseId,
        status,
      }
    );
  setActiveDeactive = (companyId: string, costCentreId: string) =>
    ApiUtility.post<IApiResponse<boolean>>(
      `${this.route}/${companyId}/SetActiveDeactive/${costCentreId}`,
      {}
    );

  getCostCentre = (companyId: string, costCentreId: string) =>
    ApiUtility.getResult<ICostCentre>(
      `${this.route}/${companyId}/${costCentreId}`,
      {}
    );

  deleteCostcenter = (companyId: string, costCentreId: string) =>
    ApiUtility.delete<IApiResponse<boolean>>(
      `${this.route}/${companyId}/${costCentreId}`
    );
}

export default new CostCentersServices();
